/* eslint-env browser */
import * as React from 'react'

const PropTypes = require('prop-types')
const classNames = require('classnames')

const PubSub = require('../../../client/clientjs/services/pub-sub')

class ScrollableCoverTabs extends React.Component {
  constructor(props) {
    super(props)
    let currentlySelectedIdx = (props.tabs || []).findIndex(tab => tab.isActive)
    if (currentlySelectedIdx === -1) {
      currentlySelectedIdx = 0
    }
    this.state = {
      tabs: props.tabs || [],
      currentlySelectedIdx,
    }
    this.goToTabIdx = this.goToTabIdx.bind(this)
    this.onTabClick = this.onTabClick.bind(this)
  }

  componentDidMount() {
    if (window) {
      window.onpopstate = event => {
        if (event.state) {
          const { tabs } = this.state
          const newTabIdx = tabs.findIndex(tab => tab.key === event.state.tabKey)

          this.goToTabIdx({ newTabIdx, pushPubSub: true })
        }
      }
    }
    this.eventId = PubSub.sub('scrollableCoverCardClick', ({ args }) => {
      const { tabs } = this.props
      const newTabIdx = (tabs || []).findIndex(tab => tab.key === args.tabKey)

      this.goToTabIdx({ newTabIdx, pushState: true, pushPubSub: true })
    })
  }

  componentWillUnmount() {
    PubSub.unsub('scrollableCoverTabClick', this.eventId)
  }

  onTabClick(e, tab, tabIdx) {
    if (e && e.preventDefault) {
      e.preventDefault()
    }

    this.goToTabIdx({ newTabIdx: tabIdx, pushState: true, pushPubSub: true })
    return false
  }

  goToTabIdx({ newTabIdx, pushState, pushPubSub }) {
    const { tabs, currentlySelectedIdx } = this.state
    const tab = tabs[newTabIdx]

    if (newTabIdx !== -1 && newTabIdx !== currentlySelectedIdx) {
      if (pushPubSub) {
        PubSub.pub('scrollableCoverTabClick', { tabKey: tab.key, longTitle: tab.longTitle })
      }
      this.setState({
        currentlySelectedIdx: newTabIdx,
      })

      if (pushState) {
        if (window.history.pushState) {
          const newurl = `${window.location.protocol}//${window.location.host}${tab.path}`
          window.history.pushState({ path: newurl, tabKey: tab.key }, '', newurl)
        }
      }
    }
  }

  render() {
    const { tabs, currentlySelectedIdx } = this.state
    const { title } = this.props

    return (
      <div className="tabs is-centered">
        <ul>
          {title && (
            <li key="____title" className="show-when-locked">
              <span className="tabs-title has-text-weight-bold has-text-white is-uppercase">{title}</span>
            </li>
          )}
          {tabs.map((tab, tabIdx) => (
            <li key={tab.key} className={classNames({ 'is-active': currentlySelectedIdx === tabIdx })}>
              <a href={tab.path} title={tab.title} onClick={e => this.onTabClick(e, tab, tabIdx)}>
                {tab.icon && (
                  <span className="icon is-small">
                    <i
                      className={classNames([tab.icon], {
                        fas: currentlySelectedIdx === tabIdx,
                        far: currentlySelectedIdx !== tabIdx,
                      })}
                      aria-hidden="true"
                    />
                  </span>
                )}
                <span>{tab.title}</span>
              </a>
            </li>
          ))}
        </ul>
      </div>
    )
  }
}

ScrollableCoverTabs.propTypes = {
  tabs: PropTypes.array.isRequired,
  title: PropTypes.string,
}

ScrollableCoverTabs.defaultProps = {
  title: null,
}

module.exports = ScrollableCoverTabs
